const $inject = [];

const currentUserService = () => {
  const service = {};
  const namespace = 'CURRENT_USER';

  service.hasAppcuesIdentity = false;

  service.store = store;
  service.get = get;
  service.clear = clear;
  service.isConsultant = isConsultant;

  function store(key, value) {
    if(key === 'debtor') {
      window.svelteStore.userDebtor.set(value);
    } else {
      localStorage.setItem(`${namespace}_${key}`, JSON.stringify(value));
      if (value && value.IsFromAuth0) {
        localStorage.setItem('IsFromAuth0', value.IsFromAuth0);
      }
    }

    return get(key);
  }

  function get(key) {
    const storedItem = localStorage.getItem(`${namespace}_${key}`);
    return storedItem ? JSON.parse(storedItem) : null;
  }

  function clear(key) {
    if(key) {
      localStorage.removeItem(`${namespace}_${key}`);
    } else {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith(namespace)) {
          localStorage.removeItem(key);
        }
      });
    }

    service.hasAppcuesIdentity = false;
  }

  function isConsultant() {
    const userInfo = get('userInfo');
    return userInfo && userInfo.Role === 'Consultant';
  }

  return service;
};

currentUserService.$inject = $inject;

export default currentUserService;



// WEBPACK FOOTER //
// ./src/services/currentUserService.js